export const transformCategoriesToString = (categories) => {
  if (!categories) return "";
  return categories
    .map((category) => category.name)
    .join(", ")
    .concat(".");
};
